import axios from "axios";
import { createToastInterface } from "vue-toastification";
import CryptoJS from 'crypto-js'

// Load Portal Schemas
import BSA from "../Models/Portals/BSA";
import BACT from "../Models/Portals/BACT";
import BNZ from "../schemas/BNZ";
import QSL from "../Models/Portals/QSL";
import IPP from "../Models/Portals/IPP";
import NBL1 from "../Models/Portals/NBL1";
import FDP from "../Models/Portals/FDP";
import NextGen from "../Models/Portals/NextGen";
import NextGen2 from "../Models/Portals/NextGen2";
import NextGenCombine from "../Models/Portals/NextGenCombine";
import BQ from "../Models/Portals/BQ";
import GOVERN from "../Models/Portals/GOVERN";
import FILE from "../Models/Portals/FILE";
import Ind_File from "../Models/Portals/Ind_File";
import TEST from "../Models/Portals/Test";
import BIGV from "../Models/Portals/BIGV";
import PAY from "../Models/Portals/Payment";
import store from "../veux/store"

const days = require("dayjs");
const key = "Enthusiam Makes the Difference"

const Server = process.env.VUE_APP_HOST_SERVER || "https://server.ownurgoal.net.au"

const toast_options = {
    // You can set your default toast options here
    timeout: 2000,
    position: "bottom-center",
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: false,
    hideProgressBar: false,
    closeButton: "button",
    icon: true,
    rtl: false,
};

// Create Toast the interface
const toast = createToastInterface(toast_options);

let authorised = false

let BQExpDate = '2000-01-01'

// Upload files to OUG Server
const upLoadFiles = (parms) => {
    let files = []
    return new Promise((resolve, reject) => {
        const toastId = toast(`Loading Files - Please Wait!`, {
            timeout: false, closeButton: false,
        });
        const baseURL = `${Server}/file/uploadMultiFiles`;    //"https://server.ownurgoal.net.au/file/uploadMultiFiles";
        axios.post(baseURL, parms)
            .then((response) => {
                toast.dismiss(toastId);
                toast.success(`Files Loaded!`, {
                    timeout: 1000,
                });
                response.data.files.forEach(file => {
                    files.push({
                        newDetails: file.filename.substr(file.filename.lastIndexOf("/") + 1, 80),
                        orgfileName: file.originalname
                    })
                });
                resolve(files);
            })
            .catch((error) => {
                toast.dismiss(toastId);
                toast.error(`File Load Error - Please try again!`, {
                    timeout: false,
                    closeOnClick: true,
                });
                reject(error)
            });
    })
}

// Encrypt String to Data
const encryptData = (pvtData) => {

    if (pvtData.length) {
        // hash the name with any algorithm
        return CryptoJS.AES.encrypt(pvtData, key).toString();
    }

}

// Set Gender to the Database Codes
const getDBGender = (gender) => {
    let result = 20
    switch (gender) {
        case 'Male':
            result = 18
            break;
        case 'Female':
            result = 19
            break;
        case 'Non-Binary':
            result = 3391
            break;
        case 'Different Identity':
            result = 3392
            break;
        case 'Prefer Not to Say':
            result = 3393
            break;
        case 'Male Competition':
            result = 18
            break;
        case 'Female Competition':
            result = 19
            break;

    }
    return result
}

//Decode the JWt Token
const parseJwt = (token) => {
    let base64Url = token.split('.')[1];
    let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    let jsonPayload = decodeURIComponent(Buffer.from(base64, "base64").toString("ascii").split("").map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
}

const NowDate = (format) => {
    let item = days()
    return days(item).format(format);
}

const fnBrowserDetect = () => {

    let userAgent = navigator.userAgent;
    let browserName;

    if (userAgent.match(/chrome|chromium|crios/i)) {
        browserName = "chrome";
    } else if (userAgent.match(/firefox|fxios/i)) {
        browserName = "firefox";
    } else if (userAgent.match(/safari/i)) {
        browserName = "safari";
    } else if (userAgent.match(/opr\//i)) {
        browserName = "opera";
    } else if (userAgent.match(/edg/i)) {
        browserName = "edge";
    } else {
        browserName = "No browser detection";
    }

    return browserName + ' - ' + userAgent;

}


export default {

    // Get the current value of BQExpDate
    getBQExpiry: () => {
        return BQExpDate
    },

    setBQExpiry: (date) => {
        BQExpDate = date
    },

    // Capitalise First Letter of each word
    capitalizeFirstLetter: (string) => {

        if (!string) { return '' }
        //split the above string into an array of strings 
        //whenever a blank space is encountered
        const arr = string.split(" ");

        //loop through each element of the array and capitalize the first letter.
        for (var i = 0; i < arr.length; i++) {
            arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);

        }

        //Join all the elements of the array back into a string 
        //using a blankspace as a separator 
        const newstring = arr.join(" ");

        return newstring;
    },
    //Decode the JWt Token
    parseJwt,
    // Get authorisation Token
    GetToken: () => {
        const curToken = localStorage.getItem("portal_Token");
        let tokenStatus = true
        if (curToken) {
            const jwtPayload = parseJwt(curToken);
            if (jwtPayload.exp < Date.now() / 1000) {
                // token expired
                tokenStatus = false
            }
        } else {
            tokenStatus = false
        }
        if (!tokenStatus) {
            return new Promise((resolve, reject) => {
                let payload = { system: "OUG_Portal" };
                const baseURL = `${Server}/auth/OUG_Check_System`;     //"https://server.ownurgoal.net.au/auth/OUG_Check_System";
                axios.post(baseURL, payload)
                    .then((response) => {
                        authorised = true;
                        axios.defaults.headers.common[
                            "Authorization"
                        ] = `Bearer ${response.data.token}`;
                        localStorage.setItem("portal_Token", response.data.token)
                        resolve(response.data.token)
                    })
                    .catch((error) => {
                        reject(error)
                    });
            })
        } else {
            authorised = true;
            axios.defaults.headers.common[
                "Authorization"
            ] = `Bearer ${curToken}`;
        }
    },
    // Format a Date
    FormatDate: (item, format) => {
        return days(item).format(format);
    },
    // Return now in a required format
    NowDate,
    // Lookup Codes
    GetCodeBy: (payload, fullRecord) => {
        if (authorised) {
            return new Promise((resolve, reject) => {
                // const payload = { Type: "NBL1 Playing Status" };
                const baseURL = `${Server}/gen/GetCodeBy`;     //"https://server.ownurgoal.net.au/gen/GetCodeBy";
                axios.post(baseURL, payload)
                    .then((response) => {
                        let retVal = []
                        response.data.result.forEach(code => {
                            (fullRecord) ? retVal.push(code) : retVal.push(code.Detail);
                        });
                        resolve(retVal);
                    })
                    .catch((error) => {
                        reject(error)
                    });
            })
        }
    },
    // Lookup Data
    getData(sql, encrypt) {
        let payload = { PayLoad: encryptData(sql), EncrytReturn: encrypt }
        return new Promise((resolve, reject) => {
            axios.post(`${Server}/gen/GetTable`, payload)
                .then(response => {
                    if (payload.EncrytReturn) {
                        resolve(JSON.parse(this.decryptData(response.data.result)))
                    }
                    resolve(response.data.result)
                }).catch(e => {
                    console.log(e)
                    reject(e)
                })
        })
    },
    // Send Email
    sendEmail(payload) {
        //payload = { User_Name, User_Email, emailstosend, Subject, Message }
        return new Promise((resolve, reject) => {
            axios.post(`${Server}/coms/SendEmail`, payload)
                .then(response => {
                    resolve(response)
                }).catch(e => {
                    console.log(e)
                    reject(e)
                })
        })
    },
    // Lookup Team Codes
    GetTeamCodeBy: (payload, fullRecord) => {
        if (authorised) {
            return new Promise((resolve, reject) => {
                // const payload = { Type: "NBL1 Playing Status" };
                const baseURL = `${Server}/gen/GetTeamCodes`;   //"https://server.ownurgoal.net.au/gen/GetTeamCodes";
                axios.post(baseURL, payload)
                    .then((response) => {
                        let retVal = []
                        response.data.result.forEach(teamcode => {
                            (fullRecord) ? retVal.push(teamcode) : retVal.push(teamcode.Detail);
                        });
                        resolve(retVal);
                    })
                    .catch((error) => {
                        reject(error)
                    });
            })
        }
    },
    // Get a List of Countries
    GetCountries: (fullRecord) => {
        return new Promise((resolve, reject) => {
            const baseURL = `${Server}/gen/GetCountries`;  //"https://server.ownurgoal.net.au/gen/GetCountries";
            axios.post(baseURL)
                .then((response) => {
                    let retVal = []
                    response.data.result.forEach(country => {
                        (fullRecord) ? retVal.push(country) : retVal.push(country.Printable_Name);
                    });
                    resolve(retVal);
                })
                .catch((error) => {
                    reject(error)
                });
        })
    },
    // Get a List of Products
    GetProducts: (Entity, Type, fullRecord) => {
        return new Promise((resolve, reject) => {
            let TypeDesc = (Type == "Team") ? "Team_id" : "Organisation"
            let payload = {
                "Entity_id": Entity,
                "Type": TypeDesc
            }
            const baseURL = `${Server}/gen/GetProducts`;  // "https://server.ownurgoal.net.au/gen/GetProducts";
            axios.post(baseURL, payload)
                .then((response) => {
                    let retVal = []
                    response.data.result.forEach(product => {
                        (fullRecord) ? retVal.push(product) : retVal.push(product.Name);
                    });
                    resolve(retVal);
                })
                .catch((error) => {
                    reject(error)
                });
        })
    },
    // Get a List of Events
    GetEvents: (payload, fullRecord) => {
        return new Promise((resolve, reject) => {
            const baseURL = `${Server}/gen/GetEvents`  //"https://server.ownurgoal.net.au/gen/GetEvents";
            axios.post(baseURL, payload)
                .then((response) => {
                    let retVal = []
                    response.data.result.forEach(event => {
                        (fullRecord) ? retVal.push(event) : retVal.push(event.title);
                    });
                    resolve(retVal);
                })
                .catch((error) => {
                    reject(error)
                });
        })
    },
    // Upload Data
    LoadData: (payload) => {
        return new Promise((resolve, reject) => {
            const toastId = toast(`Processing your Submission - Please Wait!`, {
                timeout: false, closeButton: false,
            });
            const baseURL = `${Server}/portal/LoadData`;  // "https://server.ownurgoal.net.au/portal/LoadData";
            axios.post(baseURL, payload)
                .then((response) => {
                    toast.dismiss(toastId);
                    toast.success(`Your Submission was sucessfully Received!`, {
                        timeout: 2000,
                    });
                    resolve(response);
                })
                .catch((error) => {
                    toast.dismiss(toastId);
                    toast.error(`There was a problem processing your submission - Support has been be notified and will be in touch!`, {
                        timeout: false,
                        closeOnClick: true,
                    });
                    reject(error)
                });
        })
    },
    // Set Gender
    getDBGender,
    // Set Gender for Comp Selection
    getCompGender: (gender) => {
        let result = 20
        switch (gender) {
            case 'Male Competition':
                result = 18
                break;
            case 'Female Competition':
                result = 19
                break;
        }
        return result
    },
    // Create Form Data from File for loading into OUG
    formDataFile: (file) => {
        let formData = new FormData();
        formData.append('UploadFile', file);
        return formData;
    },
    // Lookup Person by various fields
    GetContact: (payload, fullRecord) => {
        if (authorised) {
            return new Promise((resolve, reject) => {
                const toastId = toast(`Validating Contact - Please Wait!`, {
                    timeout: false, closeButton: false,
                });
                // example below but use any Contacts columns
                // payload = {
                //     "Login": "FRED",
                //     "Date_Of_Birth": "2000-02-25"
                // }
                const baseURL = `${Server}/gen/GetContactsBy`;  //"https://server.ownurgoal.net.au/gen/GetContactsBy";
                axios.post(baseURL, payload)
                    .then((response) => {
                        let retVal = []
                        response.data.result.forEach(contact => {
                            (fullRecord) ? retVal.push(contact) : retVal.push(contact.Contact_id);
                        });
                        if (retVal.length == 0 || retVal.length > 1) {
                            let message = `We found more than one user with your user details - 
                                        Please contact OwnUrGoal at support@ownurgoal.zendesk.com`
                            if (retVal.length == 0) {
                                message = `We could not find any record with this combination of username and date of birth in OwnUrGoal - please check these and try again`
                            }
                            toast.dismiss(toastId);
                            toast.error(message, {
                                timeout: false,
                                closeOnClick: true,
                            });
                        } else {
                            toast.dismiss(toastId);
                        }
                        resolve(retVal);
                    })
                    .catch((error) => {
                        toast.dismiss(toastId);
                        toast.error(`There was a problem Validating your user details - Please check the Username and Date of Birth match your OwnUrGoal Details!`, {
                            timeout: false,
                            closeOnClick: true,
                        });
                        reject(error)
                    });
            })
        }
    },
    // Update Data in OUG
    UpdateTable: (payload) => {
        if (authorised) {
            return new Promise((resolve, reject) => {
                const toastId = toast(`Updating Data to OwnUrGoal - Please Wait!`, {
                    timeout: false, closeButton: false,
                });
                // {
                //     "Payload": ContactDetails,
                //     "Table": "Contact_Details",
                //     "Primary_Key": "Contact_Details_id",
                //     "Action": "INSERT"
                // }
                const baseURL = `${Server}/gen/EditTable`; //"https://server.ownurgoal.net.au/gen/EditTable";
                axios.post(baseURL, payload)
                    .then((response) => {
                        toast.dismiss(toastId);
                        toast.success(`Your Data was sucessfully Updated!`, {
                            timeout: 2000,
                        });
                        resolve(response);
                    })
                    .catch((error) => {
                        toast.dismiss(toastId);
                        toast.error(`We had an issue updating your data - Support have been notified and will be in touch!`, {
                            timeout: false,
                            closeOnClick: true,
                        });
                        reject(error)
                    });
            })
        }
    },
    // Upload files to OUG Server
    upLoadFiles,
    //TODO might see if we can delete this function as we have the upLoadFiles function that does the same thing
    upLoadFile(file, obj) {
        return new Promise((resolve, reject) => {
            const toastId = this.$toast(`Loading File - Please Wait!`, {
                timeout: false, closeButton: false,
            });
            const baseURL = `${Server}/file/uploadSingleFile`; //"https://server.ownurgoal.net.au/file/uploadSingleFile";
            axios.post(baseURL, file)
                .then((response) => {
                    this.$toast.dismiss(toastId);
                    this.$toast.success(`File Loaded!`, {
                        timeout: 1000,
                    });
                    this.files.push({ Type: Number(obj.Doc_id), Description: obj.Doc_Label, Details: response.data.filename.substr(response.data.filename.lastIndexOf("/") + 1, 80) })
                    resolve(response);
                })
                .catch((error) => {
                    this.$toast.dismiss(toastId);
                    this.$toast.error(`File Load Error - Please try again!`, {
                        timeout: false,
                        closeOnClick: true,
                    });
                    reject(error)
                });
        })
    },
    // Get the current Module Functions
    GetSchemaFunction: (Func, Parms, data) => {
        return new Promise((resolve, reject) => {
            switch (Func) {
                case 'INIT':
                    switch (Parms.Portal) {
                        case "BIGV":
                            resolve(BIGV.init(Parms));
                            break;
                        case "BSA":
                            resolve(BSA.init(Parms));
                            break;
                        case "BACT":
                            resolve(BACT.init(Parms));
                            break;
                        case "BNZ":
                            resolve(BNZ.init(Parms));
                            break;
                        case "NBL1":
                            resolve(NBL1.init(Parms));
                            break;
                        case "NextGen":
                            resolve(NextGen.init(Parms));
                            break;
                        case "NextGen2":
                            resolve(NextGen2.init(Parms));
                            break;
                        case "NextGenCombine":
                            resolve(NextGenCombine.init(Parms));
                            break;
                        case "QSL":
                            resolve(QSL.init(Parms));
                            break;
                        case "IPP":
                            resolve(IPP.init(Parms));
                            break;
                        case "BQ":
                            resolve(BQ.init(Parms));
                            break;
                        case "PAY":
                            resolve(PAY.init(Parms));
                            break;
                        case "FDP":
                            resolve(FDP.init(Parms));
                            break;
                        case "GOVERN":
                            resolve(GOVERN.init(Parms));
                            break;
                        case "FILE":
                            resolve(FILE.init(Parms));
                            break;
                        case "Ind_File":
                            resolve(Ind_File.init(Parms));
                            break;
                        case "TEST":
                            resolve(TEST.init(Parms));
                            break;

                        default:
                            break;
                    }
                    break;
                default:
                    break;
            }


        })
    },

    // Prepare the data into a payload
    saveData: async (data) => {
        let steps = data.steps,
            Model = data.Model,
            Field,
            Data,
            Schema,
            Contact_Details = [],
            Current_Details = store.getters.userDetails,
            filteredDetails = [],
            Garbage = [],
            Contact = {},
            Contact_Roles = [],
            Accreditations = [],
            Bookings = [],
            Answers = [],
            files = [],
            currentFile = null,
            formData = new FormData();

        for (const property in Model) {
            Field = property
            Data = Model[Field]
            steps.forEach(step => {
                if (step.Schema[Field]) {
                    Schema = step.Schema[Field]
                }
            });
            if (Schema.OUG) {

                // Update Contacts
                if (Schema.OUG.Contacts) {
                    // Contacts
                    if (Schema.OUG.Contacts.Field === 'gender') {
                        Contact[Schema.OUG.Contacts.Field] = getDBGender(Data)
                    } else {
                        Contact[Schema.OUG.Contacts.Field] = Data
                    }
                }

                // Update Contact Details
                if (Schema.OUG.Contact_Details) {

                    if (Schema.type == 'file') {
                        // Handle multiple files in one field to load
                        // where Detail has an array of files
                        if (Array.isArray(Data)) {
                            let DescExt = 1
                            Data.forEach(file => {
                                Contact_Details.push({
                                    Field: Field,
                                    Type: Schema.OUG.Contact_Details.Type,
                                    Description: `${Schema.OUG.Contact_Details.Description}${DescExt == 1 ? '' : ' - ' + DescExt}`,
                                    Detail: file,
                                    Action: Schema.OUG.Contact_Details.Action // Unique, SingleDesc or Multiple
                                })
                                DescExt++
                            });

                        } else {
                            Contact_Details.push({
                                Field: Field,
                                Type: Schema.OUG.Contact_Details.Type,
                                Description: Schema.OUG.Contact_Details.Description,
                                Detail: Data,
                                Action: Schema.OUG.Contact_Details.Action // Unique, SingleDesc or Multiple
                            })
                        }
                    } else {
                        Contact_Details.push({
                            Field: Field,
                            Type: Schema.OUG.Contact_Details.Type,
                            Description: `${Data}${Schema.addText ? Schema.addText : ''}`,
                            Action: Schema.OUG.Contact_Details.Action
                        })
                    }

                    // Collect Garbage Collection Actions on userDetails
                    // Schema.OUG.Contact_Details.Action = Unique, SingleDesc or Multiple
                    if (Current_Details && Current_Details.length > 0) {
                        filteredDetails = []
                        switch (Schema.OUG.Contact_Details.Action) {
                            case 'Unique':
                                // Filter any Current_Details with matching Type
                                filteredDetails = Current_Details.filter((element) => {
                                    return element.Type === Schema.OUG.Contact_Details.Type
                                })
                                break;

                            case 'SingleDesc':
                                // Filter any Current_Details with matching Type and Description 
                                filteredDetails = Current_Details.filter((element) => {
                                    return (element.Type === Schema.OUG.Contact_Details.Type
                                        && element.Description === Schema.OUG.Contact_Details.Description)
                                })
                                break;

                            default:
                                break;
                        }
                        if (filteredDetails.length > 0) {
                            filteredDetails.forEach(filter => {
                                Garbage.push({
                                    id: filter.Contact_Details_id,
                                    Contact_id: Contact.Contact_id,
                                    Description: filter.Description,
                                    Action: "Delete"
                                })
                            });
                        }
                    }


                }

                // Update the Contact Roles
                if (Schema.OUG.Contact_Roles) {
                    // Check if multiple teams
                    if (Array.isArray(Data)) {
                        let Assoc, Accred
                        Data.forEach(team => {

                            Contact_Roles.push({
                                LinkType: Schema.OUG.Type,
                                Name: team.Detail,
                                Code_id: team.Code_id,
                                Role_id: Schema.Role
                            })

                            Assoc = team.Association
                            Accred = Schema.Accreditation

                        });

                        // Update Contact Assocation to match the team selected
                        Contact.association = Assoc

                        // Update the Accreditations
                        if (Schema.Accreditation) {
                            Accreditations.push({
                                Accreditation: Accred,
                                Start_Date: Schema.AccredStart,
                                End_Date: Schema.AccredEnd,
                                Team_id: Schema.AccredTeam
                            })
                        }

                    } else {
                        // Singular Team
                        Contact_Roles.push({
                            LinkType: Schema.OUG.Type,
                            Name: Data.Detail,
                            Code_id: Data.Code_id,
                            Role_id: Schema.Role
                        })

                        // Update Contact Assocation to match the team selected
                        if (Data.Association) {
                            Contact.association = Data.Association
                        }

                        // Update the Accreditations
                        if (Schema.Accreditation) {
                            Accreditations.push({
                                Accreditation: Schema.Accreditation,
                                Start_Date: Schema.AccredStart,
                                End_Date: Schema.AccredEnd,
                                Team_id: Schema.AccredTeam
                            })
                        }
                    }

                }

                // Update the Bookings
                if (Schema.OUG.Bookings) {

                    if (Array.isArray(Data)) {
                        Data.forEach(booking => {

                            Bookings.push({
                                BookingDate: NowDate('YYYY-MM-DD HH:MM:ss'),
                                Event_id: booking.event_id,
                            })

                        });

                    } else {
                        Bookings.push({
                            BookingDate: NowDate('YYYY-MM-DD HH:MM:ss'),
                            Event_id: Data.event_id,
                        })
                    }

                }

                // Update the Answers
                if (Schema.OUG.Answer) {
                    Answers.push({
                        Field: Field,
                        Description: Data
                    })
                }

            }
        }

        // Process files to the server
        Contact_Details.forEach(contdet => {
            if (contdet.Detail) {
                formData.append('UploadFiles', contdet.Detail);
            }
        });

        files = await upLoadFiles(formData)

        files.forEach(file => {
            currentFile = Contact_Details.find((current) => {
                return (current.Detail) && (current.Detail.name) && (current.Detail.name === file.orgfileName)
            })
            if (currentFile) {
                currentFile.Detail = file.newDetails
                if (currentFile.Field === 'photo') {
                    Contact.photo = file.newDetails
                }
            }
        });

        return {
            Portal_Data: Model,
            Portal: data.Portal,
            Browser: fnBrowserDetect(),
            Contact,
            Contact_Details,
            Contact_Roles,
            Accreditations,
            Bookings,
            Answers,
            Garbage
        }
    }

};